import { GET_DATA, SET_BUILDING_DASHBOARD, SET_FLOOR_DASHBOARD, SET_PROJECT_DASHBOARD } from '../actions/types';

export const dataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_DATA:
      return { loading: false, dataList: action.payload };
    default:
      return state;
  }
};

export const ProjectReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_PROJECT_DASHBOARD:
      return { loading: false, data: action.payload };
    default:
      return state;
  }
};

export const BuildingReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_BUILDING_DASHBOARD:
      return { loading: false, data: action.payload };
    default:
      return state;
  }
};

export const FloorReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_FLOOR_DASHBOARD:
      return { loading: false, data: action.payload };
    default:
      return state;
  }
};





